import { render } from "./Loader.vue?vue&type=template&id=07d28f38"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mac/Desktop/HMM-Projects/posvue-version-one/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__